export default function ($translate) {
    return {
        KEYS: {
            SUBMITTED: 'SUBMITTED',
            APPROVED: 'APPROVED',
            COMPLETED: 'COMPLETED',
            DECLINED: 'DECLINED'
        },
        LABELS: {
            SUBMITTED: $translate.instant('course.application.Submitted'),
            APPROVED: $translate.instant('course.application.Approved'),
            COMPLETED: $translate.instant('course.application.Completed'),
            DECLINED: $translate.instant('course.application.Declined')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/course/applicationStatus/index.js